var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DeviceLayout',{attrs:{"preview-data":{ name: _vm.previewNameLang, type: 'BrightnessSensor' },"device-icon":"light-switch_on","is-preview":true},scopedSlots:_vm._u([{key:"basic-controls",fn:function(){return [_c('div',{staticClass:"brightness-sensor"},[_c('div',[_vm._v("0,58 kLux")])])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }